<template>
  <div class="Site PageBox">
    <van-nav-bar
      left-arrow
      fixed
      :title="$t('Invest[0]')"
      :border="false"
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <div v-if="projectData" style="padding: 0 12px">
        <div class="ProjectPanel" v-for="item in projectData[0].projectlist" :key="item.id">
          <van-image
            width="100%"
            height="190"
            fit="cover"
            lazy-load
            :src="InitData.setting.up_url+item.img_icon"
          />
          <div class="title">
            <span>{{item.title}}</span>
            <div style="text-align:right">
              
              <span style="color:var(--color-active);"><em>{{InitData.currency}}</em>{{item.Starting_money}}</span>
              <p style="font-size: 12px;color:var(--color-assist);">{{$t('Invest[7]')}}</p>
            </div>
          </div>
          <ul class="info">
            <li v-if="Number(item.nian_income)">
              <span>{{item.nian_income}}<em>%</em></span>
              <p>{{$t('Invest[2]')}}</p>
            </li>
            <li v-else>
              <span>{{item.Daily_income}}<em>%</em></span>
              <p>{{$t('Invest[3]')}}</p>
            </li>
            <li>
              <span>{{item.Project_duration}}<em>{{$t('Invest[4]')}}</em></span>
              <p>{{$t('Invest[5]')}}</p>
            </li>
            <li v-if="!Number(item.nian_income)">
              <span>{{$Util.KeepDecimal(item.Daily_income*item.Project_duration,2)}}<em>%</em></span>
              <p>{{$t('Invest[6]')}}</p>
            </li>
            <!-- <li>
              <span><em>{{InitData.currency}}</em>{{item.Starting_money}}</span>
              <p>{{$t('Invest[7]')}}</p>
            </li> -->
          </ul>
          <div style="padding: 16px">
            <van-button v-if="item.xmmax" round size="small" block color="linear-gradient(#fba030,#f83a3a)" style="height:36px;font-size: 15px" @click="openSku(item)">{{$t('Invest[10]')}}</van-button>
            <van-button v-else round size="small" block color="var(--color-assist)" style="height:36px;font-size: 15px">{{$t('Invest[11]')}}</van-button>
          </div>
          <!-- <ul class="con">
            <li>
              {{$t('Invest[8]',{num: item.mmax})}}
              <br>
              {{$t('Invest[9]',{currency:InitData.currency,project_scale:item.Project_scale})}}
              <br>
              {{item.Repayment_method_info}}
            </li>
            <li>
              <van-button v-if="item.xmmax" round size="small" color="linear-gradient(#fba030,#f83a3a)" style="padding:0 12px;height:34px" @click="openSku(item)">{{$t('Invest[10]')}}</van-button>
              <span v-else>{{$t('Invest[11]')}}</span>
            </li>
          </ul> -->
          <!-- <div class="progress">
            <label>{{$t('Invest[12]')}}：</label>
            <van-progress stroke-width="8" color="var(--color-active)" :percentage="item.percent?$Util.KeepDecimal(item.percent,2):$Util.KeepDecimal(($Util.PointFormat(item.Project_scale)-$Util.PointFormat(item.Project_remaining))/$Util.PointFormat(item.Project_scale)*100,2)" :show-pivot="false" />
            <span>{{item.percent?$Util.KeepDecimal(item.percent,2):$Util.KeepDecimal(($Util.PointFormat(item.Project_scale)-$Util.PointFormat(item.Project_remaining))/$Util.PointFormat(item.Project_scale)*100,2)}}%</span>
          </div> -->
          <span v-if="!item.xmmax" class="seal">
            <img :src="`./static/images/seal-${$i18n.locale}.png`" height="100%">
          </span>
        </div>
      </div>
      <van-loading  v-else class="DataLoad" size="60px" vertical>{{$t('dialog[6]')}}</van-loading>
    </div>
    <van-popup
      v-model="showSku"
      round
      closeable
      position="bottom"
      safe-area-inset-bottom
      z-index="3001"
      :style="{height: 'auto'}"
    >
      <div class="SkuPopup">
        <van-grid :column-num="1" :border="false">
          <van-grid-item :text="UserInfo.balance">
            <template slot="icon">
              {{$t('Invest[13]')}}({{InitData.currency}})
            </template>
          </van-grid-item>
          <!-- <van-grid-item :text="infoData.Project_remaining">
            <template slot="icon">
              {{$t('Invest[14]')}}({{InitData.currency}})
            </template>
          </van-grid-item> -->
        </van-grid>
       <!--  <van-cell :border="false">
          <div style="font-size: 16px;">{{infoData.title}}</div>
        </van-cell>
        <van-cell :title="$t('Invest[16]')" :border="false">
          {{InitData.currency}} <b>{{infoData.Starting_money}}</b>
        </van-cell>
        <van-cell :title="$t('Invest[17]')" :border="false">
          <div v-html="infoData.interest_time_info"></div>
        </van-cell> -->
        <van-form show-error @submit="submitOrder">
          <van-field v-show="false" name="pid" :value="infoData.id" readonly />
          <van-field v-model="moneyVal" name="jiner" :label="$t('Invest[18]')" input-align="right" :border="false">
            <template #input>
              <van-stepper 
                v-model="moneyVal"
                :step="$Util.PointFormat(infoData.Increase_money)" 
                :min="$Util.PointFormat(infoData.Starting_money)" 
                :max="$Util.PointFormat(infoData.Project_remaining)"
                input-width="90px"
                button-size="40px"
              />
            </template>
          </van-field>
          <!-- <div class="tips">
            {{$t('Invest[19]')}} <i>{{InitData.currency}} {{infoData.Starting_money}}</i>, <i>{{InitData.currency}} {{infoData.Increase_money}}</i>{{$t('Invest[20]')}}, {{$t('Invest[21]')}}: <i>{{InitData.currency}} {{$Util.KeepDecimal(moneyVal*infoData.Daily_income/100*$Util.PointFormat(infoData.Project_duration),2)}}</i>
          </div> -->
          <van-field
            v-model="fundWord" 
            name="pw"
            type="password"
            clearable
            :label="$t('Invest[22]')"
            :rules="[{ required: true }]"
            :placeholder="$t('Invest[23]')"
            :border="false"
          />
          <div class="bottom">
            <van-button type="danger" round block style="font-size: 16px">{{$t('Invest[24]')}}</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'List',
  components: {
  },
  props: [],
  data() {
    return {
      projectData: '',
      showSku: false,
      infoData: {},
      moneyVal: '',
      fundWord: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getProjectList()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    getProjectList() {
      this.$Model.GetProjectList((data)=>{
        this.projectData = data
      })
    },
    openSku(data) {
      this.moneyVal = this.$Util.PointFormat(data.Starting_money)
      this.infoData = data
      if(!localStorage['Token']){
        this.$router.push('/login')
        return
      }
      // if(!this.$store.state.UserInfo.realname){
      //   this.$Dialog.Alert(this.$t('Invest[25]'),()=>{
      //     this.$router.push('/user/set/realname')
      //   });
      //   return
      // }
      if(this.$store.state.UserInfo.is_fund_password!=1){
        this.$Dialog.Alert(this.$t('Invest[26]'),()=>{
          this.$router.push('/user/info')
        })
        return
      }
      this.showSku = true
    },
    submitOrder(json) {
      this.$Model.InvestOrder(json,(data)=>{
        if(data.code==1){
          this.showSku = false
          this.getProjectList()
        }
      })
    },
  }
}
</script>
<style scoped>
.ProjectPanel {
  overflow: hidden;
  width: 100%;
  margin: 15px 0;
  background-color: #fff;
  box-shadow: 0 0.1875rem 0.5rem rgba(252, 95, 53, .1);
  border-radius: 8px;
  position: relative;
}

.ProjectPanel > a {
  display: block;
  position: relative;
}

.ProjectPanel .van-image {
  display: block;
}

.ProjectPanel .title {
  font-size: 16px;
  padding: 10px;
  border-bottom: 1px #eee solid;
  display: flex;
  align-items: center;
  line-height: 1;
  margin: 0 5px;
}
.ProjectPanel .title span{
  flex: auto;
  word-break: break-word;
}
.ProjectPanel .title a{
  font-size: 12px;
  opacity: .8;
  flex: none;
}
.ProjectPanel .title i {
  font-size: 14px;
  color: #fff;
  background-color: #54a500;
  border-radius: 100%;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  margin-right: 5px;
  overflow: hidden;
  flex: none;
}

.ProjectPanel .info {
  display: flex;
  padding: 12px 15px;
  justify-content: space-between;
}

.ProjectPanel .info li {
  line-height: 1;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-items: center;
  text-align: center;
}

.ProjectPanel .info li > span {
  font-size: 20px;
  margin-bottom: 8px;
  color: var(--color-active);
}
.ProjectPanel .info li > p {
  color: var(--color-assist);
}

.ProjectPanel .info li > span em {
  font-size: 14px;
}

.ProjectPanel .con {
  font-size: 13px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.5;
}

.ProjectPanel .con .van-button {
  font-size: 14px;
}

.ProjectPanel .progress {
  line-height: 1;
  font-size: 12px;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ProjectPanel .progress .van-progress {
  flex: auto;
}

.ProjectPanel .progress>span {
  font-size: 15px;
  margin-left: 8px;
}

.ProjectPanel .seal{
  height: 100px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.ProjectPanel .seal img{
  object-fit: contain;
}

.van-popup>>>.van-popup__close-icon{
  color: #fff;
  top: 10px;
  right: 10px;
}
.SkuPopup .van-grid{
  background-image: url('../../../public/static/images/default/task_bg.png'),linear-gradient(to right,#f83a3a,#fba030);
  background-repeat: no-repeat;
  background-size: 100%;
}
.SkuPopup .van-grid>>>.van-grid-item__content{
  background-color: transparent;
  color: rgba(255, 255, 255, .8);
  font-size: 12px;
  line-height: 1;
  padding: 20px 0;
  justify-content: space-between;
  text-align: center;
}
.SkuPopup .van-grid>>>.van-grid-item__text{
  font-size: 22px;
  margin-top: 10px;
  color: #fff;
}
.SkuPopup .van-cell{
  padding: 0 15px;
  margin: 15px 0;
}
.SkuPopup>>>.van-cell__title{
  color: var(--color-assist);
  width: 6.2em;
  flex: none;
}
.SkuPopup>>>.van-cell__value{
  color: var(--color-main);
}
.SkuPopup>>>.van-cell__value b{
  color: var(--color-active);
}
.SkuPopup .van-cell__value input[type='password']{
  width: 55vw;
  border: 1px #eee solid;
  padding: 8px 5px;
  font-size: 13px;
  color: #333;
  border-radius: 3px;
}
.SkuPopup .van-stepper>>>.van-stepper__input{
  font-size: 18px;
  color: #333;
}
.SkuPopup>>>input.van-field__control{
  background-color: #f2f3f5;
  height: 40px;
  border-radius: 5px;
  padding: 0 10px;
}
.SkuPopup .tips{
  color: var(--color-assist);
  font-size: 12px;
  padding: 0 15px;
  line-height: 1;
  text-align: right;
}
.SkuPopup .tips i{
  color: var(--color-active);
}
.SkuPopup .bottom{
  padding: 15px;
}
</style>